module.exports = __webpack_public_path__ + "img/image-009.10a6d315.png";